<file-preview-toolbar [showCloseButton]="true" (closed)="closeOverlay()"></file-preview-toolbar>
<preview-container [files]="entries" #previewContainer></preview-container>